// extracted by mini-css-extract-plugin
export default {"favoriteIcon":"SavedFiltersDrawer_favoriteIcon__CVuiV","details":"SavedFiltersDrawer_details__ms1fe","avatar":"SavedFiltersDrawer_avatar__Cd2Kb"};